import { render, staticRenderFns } from "./viewUniversity.vue?vue&type=template&id=00895968"
import script from "./viewUniversity.vue?vue&type=script&lang=js"
export * from "./viewUniversity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports